module.exports = __webpack_public_path__ + "media/WeChat_20220830180644.641e4fda.mp4";